import React from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";

function PatientVitalDetail({ item }) {
    return (
        <div className="row justify-content-center m-b-20">
            <div className="col-md-12">
                <div className="row">
                    <div className="col-4 bg-primary">
                        <h5>Patient Vital Result</h5>
                    </div>
                    <div className="col-md-12">
                        <table className="table table-bordered">
                            <tbody>
                                {item.questions &&
                                    item.questions.map((a, i) => (
                                        <tr key={i}>
                                            <td style={{ width: "30%" }}>
                                                <strong>{a.question}</strong>
                                            </td>
                                            <td>
                                                <span
                                                    style={{
                                                        marginRight: "4px",
                                                    }}
                                                    className="badge badge-primary"
                                                >
                                                    {a.answer}
                                                </span>{" "}
                                                {a.value === "0" && (
                                                    <span
                                                        style={{
                                                            marginRight: "4px",
                                                        }}
                                                        className="badge badge-primary"
                                                    >
                                                        GOOD
                                                    </span>
                                                )}
                                                {a.value === "1" && (
                                                    <span
                                                        style={{
                                                            marginRight: "4px",
                                                        }}
                                                        className="badge badge-warning"
                                                    >
                                                        Attention
                                                    </span>
                                                )}
                                                {a.value === "2" && (
                                                    <span
                                                        style={{
                                                            marginRight: "4px",
                                                        }}
                                                        className="badge badge-pink"
                                                    >
                                                        Warning
                                                    </span>
                                                )}
                                                {a.value === "3" && (
                                                    <span
                                                        style={{
                                                            marginRight: "4px",
                                                        }}
                                                        className="badge badge-danger"
                                                    >
                                                        Alert
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-4 bg-primary">
                        <h5>Detail</h5>
                    </div>
                    <div className="col-12">
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <td style={{ width: "30%" }}>
                                        <strong>Date & Time</strong>
                                    </td>
                                    <td>{cleanDate(item.created_at)}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "30%" }}>
                                        <strong>Result Score</strong>
                                    </td>
                                    <td>
                                        <span className="badge badge-primary">{item.score}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ width: "30%" }}>
                                        <strong>Initial</strong>
                                    </td>
                                    <td>
                                        <span className="text-primary">{item.initial}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ width: "30%" }}>
                                        <strong>Monitoring Frequency</strong>
                                    </td>
                                    <td>
                                        <span className="text-primary">{item.frequency}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ width: "30%" }}>
                                        <strong>EScalation of care</strong>
                                    </td>
                                    <td>
                                        <span className="text-primary">{item.care}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ width: "30%" }}>
                                        <strong>Staff</strong>
                                    </td>
                                    <td>
                                        <StaffProfileCard item={item.author} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PatientVitalDetail;
